export type RuntimeConfig = Partial<{
  VITE_API_BASE_URL: string;
  VITE_API_PORT: string;
  VITE_BASE_URL: string;
  VITE_CLIENT_URL: string;
  VITE_SENTRY_DSN_WEB: string;
  VITE_MCP_SERVER_URL: string;
  VITE_ALLOW_WEAK_PASSWORDS: string;
  VITE_STRIPE_ENABLED: string;
  VITE_PHONE_SIGN_IN_ENABLED: string;
  VITE_PASSKEY_SIGN_IN_ENABLED: string;
  VITE_APP_ENV: string;
}>;

declare global {
  interface Window {
    __PREVIXIO_RUNTIME_CONFIG__?: RuntimeConfig;
  }
}

const buildTimeConfig: RuntimeConfig = {
  VITE_API_BASE_URL: import.meta.env.VITE_API_BASE_URL,
  VITE_API_PORT: import.meta.env.VITE_API_PORT,
  VITE_BASE_URL: import.meta.env.VITE_BASE_URL,
  VITE_CLIENT_URL: import.meta.env.VITE_CLIENT_URL,
  VITE_SENTRY_DSN_WEB: import.meta.env.VITE_SENTRY_DSN_WEB,
  VITE_MCP_SERVER_URL: import.meta.env.VITE_MCP_SERVER_URL,
  VITE_ALLOW_WEAK_PASSWORDS: import.meta.env.VITE_ALLOW_WEAK_PASSWORDS,
  VITE_APP_ENV: import.meta.env.VITE_APP_ENV,
  VITE_STRIPE_ENABLED: import.meta.env.VITE_STRIPE_ENABLED,
  VITE_PHONE_SIGN_IN_ENABLED: import.meta.env.VITE_PHONE_SIGN_IN_ENABLED,
  VITE_PASSKEY_SIGN_IN_ENABLED: import.meta.env.VITE_PASSKEY_SIGN_IN_ENABLED,
};

const runtimeOverrides =
  typeof window === 'undefined' ? {} : window.__PREVIXIO_RUNTIME_CONFIG__;

export const runtimeConfig = Object.freeze({
  ...buildTimeConfig,
  ...runtimeOverrides,
});
